<template functional>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <ul class="flex flex-wrap">
      <li class="mr-4">
        <img
          src="@/assets/images/logos/pay-logo-mastercard.svg"
          alt="Логотип платежной системы Mastercard"
          class="w-10 h-auto"
        />
      </li>
      <li class="mr-4">
        <img
          src="@/assets/images/logos/pay-logo-visa.svg"
          alt="Логотип платежной системы Visa"
          class="w-10 h-auto"
        />
      </li>
      <li class="mr-0">
        <img
          src="@/assets/images/logos/pay-logo-mir.svg"
          alt="Логотип платежной системы МИР"
          class="w-10 h-auto"
        />
      </li>
    </ul>

    <div class="text-right">
      <p>
        ИНН 7731398051. Ассоциация «КЛУБ ГРАФСКИЕ ПРУДЫ».
        <a
          href="https://nc.vngrdv.online/docs/%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D1%81%D0%BA%D0%BE%D0%B5%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5.docx"
          class="underline block"
          >Пользовательское соглашение</a
        >
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String,
    },
  },
};
</script>
